const ED25519_PUBLIC_KEY = Uint8Array.from([
  0xd7, 0x5a, 0x98, 0x01, 0x82, 0xb1, 0x0a, 0xb7, 0xd5, 0x4b, 0xfe, 0xd3, 0xc9, 0x64, 0x07, 0x3a, 0x0e, 0xe1, 0x72,
  0xf3, 0xda, 0xa6, 0x23, 0x25, 0xaf, 0x02, 0x1a, 0x68, 0xf7, 0x07, 0x51, 0x1a,
]);

export async function isSignedRoleCryptoSupported(): Promise<boolean> {
  const browserCrypto = Reflect.get(globalThis, "crypto") as { subtle?: SubtleCrypto } | undefined;
  if (!browserCrypto?.subtle) {
    return false;
  }

  try {
    await browserCrypto.subtle.importKey("raw", ED25519_PUBLIC_KEY, { name: "Ed25519" }, false, ["verify"]);
    return true;
  } catch {
    return false;
  }
}
